import resolveCoursewareIds from './resolveCoursewareIds';

let _contextInput = {};
let _context = resolveCoursewareIds();

/**
 * App-wide courseware scope (course / lesson / unit / workspace).
 * Set when entering authoring (e.g. lesson builder); read from GTM, tools, or other features.
 */
export function setCoursewareContext(ids = {}) {
  _contextInput = { ..._contextInput, ...ids };
  _context = resolveCoursewareIds(_contextInput);
}

export function clearCoursewareContext() {
  _contextInput = {};
  _context = resolveCoursewareIds();
}

/** Resolved ids for the current authoring scope. */
export function getCoursewareContext() {
  return { ..._context };
}

/**
 * SPF stage selection data: section id lives on `ref` for section clicks;
 * `stageRef` is the parent stage ref, not the section.
 */
export function getSectionIdFromStageSelection(selection) {
  if (!selection) {
    return '';
  }

  return selection.ref || selection.sectionRef || selection.stageRef || '';
}

export function syncSectionIdFromStageSelection(selection) {
  setCoursewareContext({ sectionId: getSectionIdFromStageSelection(selection) });
}

export { resolveCoursewareIds };
